export default __webpack_public_path__ + "static/media/src2.999630a2.mp3";